/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-progress/bulb-transcoding/bulbtranscodingcommand
 */

import { Command, ModelWriter } from 'ckeditor5';
import { cancelBusyIndicator } from '../../utils';

/**
 * The bulb attached file command, the actual insert capabilities of the plugin.
 *
 * @extends Command
 */
export class InsertBulbTranscoderCommand extends Command {

  public override execute(transcodingDetails, placeholderElement, insertPosition) {
    this.editor.model.change((writer: ModelWriter) => {
      this.editor.model.insertContent(this.createTranscodingBlock(writer, transcodingDetails), insertPosition);
      cancelBusyIndicator(this.editor);
      if (placeholderElement) {
        writer.remove(placeholderElement);
      }
    });
  }

  public override refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'bulbTranscoder');

    this.isEnabled = allowedIn !== null;
  }

  /**
   * Function which creates transcoding block.
   * @param writer
   * @param transcodingDetails  Details containing information about block type and id.
   *
   */
  private createTranscodingBlock(writer: ModelWriter, transcodingDetails) {
    // TODO TAM clean : need to ask if we need this ( don't think we do ).
    // const assetId = (transcodingDetails.contentBlock.blockType === 'VIDEO')
    //   ? transcodingDetails.contentBlock.video.id : transcodingDetails.contentBlock.audio.id;

    return writer.createElement('bulbTranscoder', {
      'bulb-block-id': transcodingDetails.contentBlock.id,
    });
  }
}
